// @flow
import React from 'react';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

type Props = {
  reservation: Object,
  isOwner: boolean,
};

class SMReservationFlowView extends React.Component {

  constructor(props: Props) {
    super(props);
  }

  getReservationStatusList(statusList: Object, phase: number) {
    let rows = [];
    const index = [1,3,2];
    for (let i of index) {
      let current = (i === phase) ? " is-current" : "",
          className = `reserve-status-bar__status${i}${current}`;
      rows.push(<li key={i} className={className}>{statusList[i]}</li>);
    }

    return rows;
  }

  render() {
    let reservation = this.props.reservation;
    let phase = 0;
    let rows = [];
    switch (reservation.status) {
      case SMConst.ReservationStatus.Sent:
        break;
      case SMConst.ReservationStatus.EntrustedOwner:
      case SMConst.ReservationStatus.Requested:
        phase = 1;
        break;
      case SMConst.ReservationStatus.Confirmed:
      case SMConst.ReservationStatus.Paying:
        phase = 2;
        break;
      case SMConst.ReservationStatus.Paid:
      case SMConst.ReservationStatus.Onsite:
      case SMConst.ReservationStatus.Invoice:
      case SMConst.ReservationStatus.Postpay:
        phase = 3;
        break;
      case SMConst.ReservationStatus.CancelSent:
      case SMConst.ReservationStatus.Cancelled:
      case SMConst.ReservationStatus.OwnerCancelled:
      case SMConst.ReservationStatus.SystemCancelled:
      case SMConst.ReservationStatus.Rejected:
      case SMConst.ReservationStatus.Refunded:
      case SMConst.ReservationStatus.Ended:
        phase = 4;
        break;
      case SMConst.ReservationStatus.Expired:
        phase = 5;
        break;
      default:
    }
    if (phase == 0) {
      let c = "reserve-status-bar__contact";
      rows.push(
        <li key={phase} className={c}>{SMFormatHelper.statusText(reservation)}</li>
      );
    }
    else if (phase == 4) {
      let c = "reserve-status-bar__cancel";
      rows.push(
        <li key={phase} className={c}>{SMFormatHelper.statusText(reservation)}</li>
      );
    }
    else if (phase == 5) {
      let c = "reserve-status-bar__expire";
      rows.push(
        <li key={phase} className={c}>{SMFormatHelper.statusText(reservation)}</li>
      );
    }
    else if (reservation.billing !== null && reservation.billing.payment_method === SMConst.PaymentMethod.Postpay && !this.props.isOwner) {
      if (!reservation.can_be_reviewed && phase === 3) phase = 2;
      const statusList = {"1": "承認/否認", "2": "予約完了", "3": "お支払い"};
      rows = this.getReservationStatusList(statusList, phase);
    }
    else {
      if (reservation.is_direct && phase == 3) {
        rows.push(<li className="reserve-status-bar__done">予約完了（今すぐ予約）</li>);
      } else {
        const statusList = {"1": "承認/否認", "2": "お支払い", "3": "予約完了"};
        rows = this.getReservationStatusList(statusList, phase);
      }
    }
    return(
      <ul className="reserve-status-bar mb20">
        {rows}
      </ul>
    );
  }
}

export default SMReservationFlowView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationFlowView.jsx